import { render, staticRenderFns } from "./PageDisabled.vue?vue&type=template&id=ef142740&scoped=true"
import script from "./PageDisabled.vue?vue&type=script&lang=js"
export * from "./PageDisabled.vue?vue&type=script&lang=js"
import style0 from "./PageDisabled.vue?vue&type=style&index=0&id=ef142740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef142740",
  null
  
)

export default component.exports